import {
  IFinixJobHealthResponse,
  IFinixSettlementListParams,
  IFinixSettlementListResponse,
  IFinixWebhookListParams,
  IFinixWebhookListResponse,
  IFinixWebhookRetryResponse,
  IFinixWebhookStatsResponse,
} from "types/FinixOps";

import { api } from ".";

// CLE-2949 — Integrations → Finix. SuperAdmin only. The API never returns a webhook's payload.
const finixOpsQueries = api.injectEndpoints({
  endpoints: (builder) => ({
    getFinixWebhookStats: builder.query<IFinixWebhookStatsResponse, number>({
      query: (days) => ({
        url: "/finix/ops/webhooks/stats",
        method: "GET",
        params: { days },
      }),
      providesTags: [{ type: "FinixOps", id: "WEBHOOK_STATS" }],
    }),
    getFinixWebhooks: builder.query<
      IFinixWebhookListResponse,
      IFinixWebhookListParams
    >({
      query: ({ status, page, pageSize }) => ({
        url: "/finix/ops/webhooks",
        method: "GET",
        params: { ...(status ? { status } : {}), page, pageSize },
      }),
      providesTags: [{ type: "FinixOps", id: "WEBHOOKS" }],
    }),
    retryFinixWebhook: builder.mutation<IFinixWebhookRetryResponse, number>({
      query: (webhookId) => ({
        url: `/finix/ops/webhooks/${webhookId}/retry`,
        method: "POST",
      }),
      invalidatesTags: [
        { type: "FinixOps", id: "WEBHOOKS" },
        { type: "FinixOps", id: "WEBHOOK_STATS" },
      ],
    }),
    getFinixSettlements: builder.query<
      IFinixSettlementListResponse,
      IFinixSettlementListParams
    >({
      query: ({ merchantId, page, pageSize }) => ({
        url: "/finix/ops/settlements",
        method: "GET",
        params: { ...(merchantId ? { merchantId } : {}), page, pageSize },
      }),
      providesTags: [{ type: "FinixOps", id: "SETTLEMENTS" }],
    }),
    getFinixJobHealth: builder.query<IFinixJobHealthResponse, void>({
      query: () => ({ url: "/finix/ops/jobs", method: "GET" }),
      providesTags: [{ type: "FinixOps", id: "JOBS" }],
    }),
  }),
});

export const {
  useGetFinixWebhookStatsQuery,
  useGetFinixWebhooksQuery,
  useRetryFinixWebhookMutation,
  useGetFinixSettlementsQuery,
  useGetFinixJobHealthQuery,
} = finixOpsQueries;
